export enum SupportedFeature {
  AddUpdateFiles = 'ADD_UPDATE_FILES',
  CopyInto = 'COPY_INTO',
  DeleteFiles = 'DELETE_FILES',
  DownloadAsZip = 'DOWNLOAD_AS_ZIP',
  FileVersions = 'FILE_VERSIONS',
  Forking = 'FORKING',
  Logs = 'LOGS',
  Permissions = 'PERMISSIONS',
  Registering = 'REGISTERING',
}
